import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { isLoadingAtom, loggedUserAtom, selectedInstallationAtom } from "../../../recoil/atoms";
import { ILoggedUser } from "../../../local-interfaces/local-interfaces";
import { useMemo, useState } from "react";
import { Button, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Toolbar, Typography, useTheme } from "@mui/material";
import logo_dark from "../../../assets/svg/header_white.svg";
import logo_light from "../../../assets/svg/header.svg";
import { useOnUser } from "../../../hooks/useOnUser";
import CreatePartnership from "./CreatePartnership";
import HandleEditInstallation from "../../../screens/Installations/modifyInstallation/EditClients";
import NotificationButton from "../../../screens/Requests/common/NotificationButton";
import useRequestNotification from "../../../screens/Requests/hooks/useRequestNotification";
import ThemeToggle from "./ThemeToggle";
import BC from "../Breadcrumbs";
import { CenterContainer } from "../../../theme/material/customizations/components";



const Header = () => {
  useRequestNotification()
  const [loggedUser] = useRecoilState<ILoggedUser | undefined>(loggedUserAtom);
  const [selectedInstallation] = useRecoilState(selectedInstallationAtom);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isLoading] = useRecoilState<boolean>(isLoadingAtom);
  const navigate = useNavigate();
  const theme = useTheme()
  const onUser = useOnUser();

  const img = useMemo(() => {
    return theme.palette.mode === 'dark' ? logo_dark : logo_light
  }, [theme.palette.mode])

  const handleLogout = async () => {
    onUser.logout();
    navigate("/");
  };

  const logoHome = () => {
    navigate("/installations");
  };

  const navigateDoc = () => {
    const openPreview = window.open("/docs/0/home");
  };

  const handleProfile = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <AppBar position="static" sx={{ height: '100%', justifyContent: 'center', bgcolor: (theme) => theme.palette.mode === 'dark' ? 'inherit' : 'background.lighter', }} >
      <Toolbar disableGutters >
        <CenterContainer borderRight={1} borderColor={'primary.light'}>
          <img src={img} alt="K" style={{
            height: '4.5vh',
            minHeight: '50px'
          }} />
        </CenterContainer>
        <Box sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}>
          <BC />
        </Box>
        <Box flexGrow={1} />
        {/* REMOVE FOR DOCS
         <Button
          size="large"
          onClick={navigateDoc}
        >
          <Typography>
            DOCS
          </Typography>
        </Button> */}
        <Button
          size="large"
          onClick={handleProfile}
        >
          <Typography marginRight={2} textTransform={'uppercase'}>
            {loggedUser?.firstname} {loggedUser?.lastname}
          </Typography>
          <AccountCircleIcon />
        </Button>
        <ThemeToggle />

        <NotificationButton />
        <Menu
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
        >
          <MenuList >
            <CreatePartnership></CreatePartnership>
            {selectedInstallation && (
              <HandleEditInstallation
                text={"Edit Clients"}
                plantID={selectedInstallation.id_plant}
              />
            )}
            <MenuItem disabled={isLoading} onClick={handleLogout}>
              <ListItemIcon><ExitToAppIcon /></ListItemIcon>
              <ListItemText>Logout</ListItemText>
            </MenuItem>
          </MenuList>
        </Menu>
      </Toolbar>
    </AppBar >
  );
}

export default Header